import {removeLayer} from "@/helpers/ol/ol-layer-helper";
import {OL3Parser, WKTReader} from "jsts/org/locationtech/jts/io";
import {GeometryFactory} from "jsts/org/locationtech/jts/geom";
import {LineString, MultiLineString, MultiPoint, MultiPolygon, Point, Polygon} from "ol/geom";
import {BufferOp} from "jsts/org/locationtech/jts/operation/buffer";
import VectorSource from "ol/source/Vector";
import {Feature} from "ol";
import VectorLayer from "ol/layer/Vector";
import {getPrintVectorLayerStyle} from "@/helpers/print/print-scales-helper";
import {Modify, Select} from "ol/interaction";
import {setDrawGeometry} from "@/helpers/ol/draw/ol-draw-polygon-helper";
import toastr from "toastr";
import {WKT} from "ol/format";
import {getFilterSelectLayerMultiPolygon} from "@/helpers/filter/filter-geometry-helper";
import {Vector} from "ol/layer";
import {getFilterVectorLayerStyle} from "@/helpers/filter/filter-helper";

let vectorLayer
let vectorSource

export function measureBuffer(geometry, buffer) {
    clearBuffer()

    // Buffer can't be 0
    if(parseInt(buffer) === 0) {
        return
    }

    const parser = new OL3Parser(new GeometryFactory(), undefined);
    parser.inject(
        Point,
        Polygon,
        MultiPoint,
        MultiLineString,
        MultiPolygon
    );

    vectorSource = new VectorSource()

    if(Array.isArray(geometry)) {
        geometry.map(geometryItem => {
            addFeatureByBuffer(parser, buffer, geometryItem)
        })
    } else {
        addFeatureByBuffer(parser, buffer, geometry)
    }

    vectorLayer = new VectorLayer({
        altitudeMode: 'clampToGround',
        name: 'bufferLayer',
        source: vectorSource,
        style: getFilterVectorLayerStyle(),
        zIndex: 1000
    })

    window.map.addLayer(vectorLayer)

    return vectorSource.getFeatures()
}

export function setBufferGeometry() {
    if(vectorSource && vectorSource.getFeatures().length > 0) {
        vectorLayer.setStyle(getFilterVectorLayerStyle())

        const multiLineStrings =  new MultiPolygon([])
        vectorSource.getFeatures().map(feature => {
            multiLineStrings.appendPolygon(feature.getGeometry())
        })

        setDrawGeometry(undefined, undefined, undefined, multiLineStrings)
    } else {
        toastr.warning('Maak eerst een buffer bij een object')
    }
}

export function clearBuffer() {
    removeLayer('bufferLayer', false)
}

function addFeatureByBuffer(parser, buffer, geometry) {
    const wkt = new WKT();
    geometry = wkt.writeGeometry(geometry)

    // Check valid geometry
    const reader = new WKTReader(new GeometryFactory());
    const geom = reader.read(geometry);

    let spBuffer = BufferOp.bufferOp(geom, buffer);
    let polyGeoJSON = parser.write(spBuffer);

    const feature = new Feature({
        geometry: new Polygon(polyGeoJSON.getCoordinates())
    })

    console.log(geometry)

    vectorSource.addFeature(feature)
}

export function createBufferByGeometry(olGeometry, buffer) {
    const parser = new OL3Parser(new GeometryFactory(), undefined);
    parser.inject(
        Point,
        LineString,
        Polygon,
        MultiPoint,
        MultiLineString,
        MultiPolygon
    );
    const jstsGeom = parser.read(olGeometry)
    const buffered = BufferOp.bufferOp(jstsGeom, buffer);
    const result = parser.write(buffered);
    return new Polygon(result.getCoordinates())
}
